import { useEffect, useState } from 'react';

const BUILDING_SIZE_INPUT_ID = 'property_research_property_attributes_building_size';

const parseBuildingSize = (raw: string) => {
  if (raw === '') return null;
  const num = parseFloat(raw);
  return Number.isFinite(num) ? num : null;
};

export const useBuildingSize = (initial: number | null): number | null => {
  const [buildingSize, setBuildingSize] = useState<number | null>(initial);

  useEffect(() => {
    const input = document.getElementById(BUILDING_SIZE_INPUT_ID);
    if (!(input instanceof HTMLInputElement)) return undefined;
    const onChange = () => setBuildingSize(parseBuildingSize(input.value));
    input.addEventListener('change', onChange);
    return () => input.removeEventListener('change', onChange);
  }, []);

  return buildingSize;
};
